import {Injectable} from '@angular/core'

import moment from 'moment';
import 'moment/locale/es';
import {LoadingController, ModalController} from 'ionic-angular';
import {Globales} from './funciones';

@Injectable()

export class Impresion {

  forzarPrefix: string = 'http://';
  forzarIp: string = '';
  forzarRuta: string = '/pstprnt';

  private etiquetaSecilla: number = 1;
  private etiquetaAvanzada: number = 2;
  private etiquetaCompleta: number = 3;
  private etiquetaSencillaLote: number = 5;
  private etiquetaRedonda: number = 7;

  constructor(
    public loadCtrl: LoadingController,
    public modalCtrl: ModalController,
    public gl: Globales,
  ) {

  }

  /**
   * Manda los datos de la produccion a la impresora para su impresion
   *
   */
  producto(data, ip = '192.168.1.10') {


    let corte = 18;
    let titulo = data.nombre.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[\u00b9-\u00be]/g, "*");
    let titulo_leng = titulo.length;
    let familia = data.familia.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[\u00b9-\u00be]/g, "*");

    let palabras = titulo.split(" ");
    let num_palabras = palabras.length;


    let suma = 0;

    for (const element of palabras) {

      let suma_aux = element.length + 1 + suma;

      if (suma_aux > 18) {

        corte = suma == 0 ? 18 : suma;
        break;

      } else {

        suma = suma_aux;
      }
    }

    let zpl: string = '';
    zpl += '^XA';
    zpl += '^FX Seccion';
    //zpl += '^CFA,35';
    zpl += '^FO15,' + (titulo_leng > corte ? 20 : 50) + '^APN,50,50^FD' + (titulo.substr(0, corte)) + '^FS';
    zpl += '^FO15,70^APN,50,50^FD' + (titulo.substr(corte)) + '^FS';
    //zpl += '^CFA,20';
    zpl += '^FO15,' + (titulo_leng > corte ? 124 : 100) + '^AQN,10,10^FD' + familia + '^FS';

    zpl += '^FO15,180^AQN,10,10^FDMIN^FS';
    zpl += '^FO140,180^AQN,10,10^FDMAX^FS';

    zpl += '^FO15,205^AQN,50,50^FD' + (data.min.general ? data.min.general : '-') + '^FS';
    zpl += '^FO140,205^AQN,50,50^FD' + (data.max.general ? data.max.general : '-') + '^FS';
    zpl += '^FO250,205^AQN,50,50^FD' + data.unidad + '^FS';

    zpl += '^FX seccion de codigo de barras';
    //zpl += '^FO5,170^GB455,90,2^FS';
    zpl += '^BY3,5,40';
    //zpl += '^FO15,180^BC,70,N^FD' + data.referencia + '^FS';
    //zpl += '^FO15,130^BQ,70,4^FD' + data.referencia + '^FS';
    //zpl += '^FO345,105^BQ,70,5^FD' + data.referencia + '^FS';
    //zpl += '^FO350,125^BQ,70,4^FD' + data.referencia + '^FS';
    zpl += '^FO350,125^BQ,70,4^FDQA,' + data.referencia + '^FS';
    zpl += '^XZ';


    let url = this.forzarPrefix + (this.forzarIp ? this.forzarIp : ip) + this.forzarRuta;
    let method = "POST";
    let async = true;
    let request = new XMLHttpRequest();

    request.onload = function () {
      let status = request.status; // HTTP response status, e.g., 200 for "200 OK"
      let data = request.responseText; // Returned data, e.g., an HTML document.
    };

    request.open(method, url, async);
    //request.setRequestHeader("Content-Length", zpl.length);

    // Actually sends the request to the server.
    request.send(zpl);

    setTimeout(() => {
      request.abort();
    }, 1000);

    //this.sendByWS(zpl);
  }


  /**
   * Manda los datos de la produccion a la impresora para su impresion
   *
   */
  productoAlbaran(data, ip = '192.168.1.10', num = 1) {


    let corte = 15;
    let titulo = data.nombre.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[\u00b9-\u00be]/g, "*");
    let titulo_leng = titulo.length;
    let subtitulo = data.subtitulo.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[\u00b9-\u00be]/g, "*");

    let palabras = titulo.split(" ");
    let num_palabras = palabras.length;

    let titlePosition = titulo_leng >= corte ? 10 : 20;
    let titleSize = titulo_leng >= corte ? 40 : 50;
    let titleSizeZpl = titleSize + ',' + titleSize;

    let suma = 0;

    for (const element of palabras) {

      let suma_aux = element.length + 1 + suma;

      if (suma_aux > 18) {

        corte = suma == 0 ? 18 : suma;
        break;

      } else {

        suma = suma_aux;
      }
    }

    let zpl: string = '';

    zpl += '^XA';
    zpl += '^FX Seccion';

    zpl += '^FO15,' + titlePosition + '^APN,' + titleSizeZpl + '^FD' + (titulo.substr(0, corte)) + '^FS';
    zpl += '^FO15,45^APN,40,40^FD' + (titulo.substr(corte)) + '^FS';

    zpl += '^FO15,90^AQN,10,10^FD' + subtitulo + '^FS';

    zpl += '^FO15,125^AQN,10,10^FDCod.: ' + data.codigo + '^FS';

    if (data.temperatura) {
      zpl += '^FO15,155^AQN,10,10^FDTemperatura: ' + data.temperatura + ' C^FS';
    }

    zpl += '^FO15,190^AQN,10,10^FDCantidad^FS';
    zpl += '^FO120,190^AQN,10,10^FDFecha recepcion^FS';

    zpl += '^FO15,215^APN,30,30^FD' + data.cantidad + '^FS';
    zpl += '^FO120,215^APN,30,30^FD' + moment(data.fecha).format('DD/MM/YYYY') + '^FS';

    if (data.fecha_caducidad) {
      zpl += '^FO300,190^AQN,10,10^FDCaducidad^FS';
      zpl += '^FO300,215^APN,30,30^FD' + moment(data.fecha_caducidad).format('DD/MM/YYYY') + '^FS';
    }

    zpl += '^FX seccion de codigo de barras';

    zpl += '^BY3,3,40';
    zpl += '^FO350,0^BQ,2,3^FDQA,' + data.codigo + '^FS';

    zpl += '^PQ' + num;

    zpl += '^XZ';


    let url = this.forzarPrefix + (this.forzarIp ? this.forzarIp : ip) + this.forzarRuta;
    let method = "POST";
    let async = true;
    let request = new XMLHttpRequest();

    request.onload = function () {
      let status = request.status; // HTTP response status, e.g., 200 for "200 OK"
      let data = request.responseText; // Returned data, e.g., an HTML document.
    };

    request.open(method, url, async);
    //request.setRequestHeader("Content-Length", zpl.length);

    // Actually sends the request to the server.
    request.send(zpl);

    setTimeout(() => {
      request.abort();
    }, 1000);

    //this.sendByWS(zpl);
  }


  /**
   * Manda los datos de la produccion a la impresora para su impresion
   *
   */
  produccion(data, ip = '192.168.1.10', tituloAlternativo = null, local, impresiones = 1) {

    const modelo = local.tipo_etiqueta.id;

    data.num_imp = impresiones;

    switch (modelo) {
      case this.etiquetaSecilla:
        const zpl = this.produccionModelo_1(data, tituloAlternativo);
        this.sentdToPrint(ip, zpl);
        break;

      case this.etiquetaAvanzada:
        this.openModalAddMoreInfoTag(data, ip, tituloAlternativo);
        break;

      case this.etiquetaCompleta:
        this.openModalAddMoreInfoTag(data, ip, tituloAlternativo, true);
        break;

      case this.etiquetaSencillaLote:
        this.openModalAddMoreInfoTag(data, ip, tituloAlternativo, false, true);
        break;

      case this.etiquetaRedonda:
        const circularZpl = this.modelEtiquetaRedonda(data);
        this.sentdToPrint(ip, circularZpl);
        break;

      default:
        this.gl.showToast('Etiqueta no disponible', 3000);
    }
  }


  /**
   * Abrir modal para meter más info a la etiqueta
   *
   */
  openModalAddMoreInfoTag(data, ip: string, tituloAlternativo = null, complete = false, onlyLot = false) {

    let modal = this.modalCtrl.create('AddMoreInfoIpresionPage', {item: data, onlyLot});

    modal.onDidDismiss((res) => {

      if (!res) {
        return false;
      }

      data.lote = res ? res.lote : "";
      data.caducidad_primaria = res ? res.caducidad_primaria : null;
      data.caducidad_primaria_has_time = res ? res.caducidad_primaria_has_time : false;
      data.caducidad_primaria_time = res ? res.caducidad_primaria_time : null;

      data.congelacion = res ? res.is_congelacion : false;

      data.descongelacion = res ? res.is_descongelacion : false;
      data.tiempo_descongelacion = res ? res.tiempo_descongelacion : 0;

      data.apertura = res ? res.is_apertura : false;
      data.tiempo_apertura = res ? res.tiempo_apertura : 0;

      data.num_imp = res ? res.num_imp : 1;

      let zpl = '';

      if (complete) {
        zpl = this.produccionModelo_3(data);

      } else if (onlyLot) {
        zpl = this.produccionModelo_4(data);

      } else {
        zpl = this.produccionModelo_2(data, tituloAlternativo);
      }

      this.sentdToPrint(ip, zpl);

    });

    modal.present();
  }


  /**
   *
   *
   */
  sentdToPrint(ip, zpl) {
    let url = this.forzarPrefix + (this.forzarIp ? this.forzarIp : ip) + this.forzarRuta;
    let method = "POST";
    let async = true;
    let request = new XMLHttpRequest();

    request.onload = function () {
      let status = request.status; // HTTP response status, e.g., 200 for "200 OK"
      let data = request.responseText; // Returned data, e.g., an HTML document.
    };
    request.open(method, url, async);
    request.send(zpl);

    setTimeout(() => {
      request.abort();
    }, 1000);
  }


  /**
   * Modelo de etiqueta antigua
   *
   */
  produccionModelo_1(data, tituloAlternativo = null) {

    let corte = 18;
    moment.locale('es');
    let produccion = moment(data.fecha_fin ? data.fecha_fin : data.fecha_impresion);
    let caducidad = moment(data.fecha_cad ? data.fecha_cad : data.fecha_caducidad);

    let tituloFinal = tituloAlternativo || data.nombre;

    let titulo = tituloFinal.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[\u00b9-\u00be]/g, "");
    let titulo_leng = titulo.length;
    let palabras = titulo.split(" ");

    let suma = 0;

    for (const element of palabras) {

      let suma_aux = element.length + 1 + suma;

      if (suma_aux > 18) {

        corte = suma == 0 ? 18 : suma;
        break;

      } else {

        suma = suma_aux;
      }
    }

    let zpl: string = '';

    zpl += '^XA';
    zpl += '^FX Seccion';
    zpl += '^FO15,' + (titulo_leng > corte ? 20 : 50) + '^APN,50,50^FD' + (titulo.substr(0, corte)) + '^FS';
    zpl += '^FO15,70^APN,50,50^FD' + (titulo.substr(corte)) + '^FS';

    zpl += '^FO15,150^AQN,10,10^FDElaborado^FS';
    zpl += '^FO15,185^ARN,10,10^FD' + ((data.usuario).slice(0, 11)).normalize("NFD").replace(/[\u0300-\u036f]/g, "") + '^FS'; // 9
    zpl += '^FO15,220^ARN,10,10^FD' + produccion.format('DD/MM/YYYY') + '^FS';

    zpl += '^FO180,150^AQN,10,10^FDCaducidad^FS';
    zpl += '^FO180,185^ARN,10,10^FD' + (caducidad.format('dddd')).normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLocaleUpperCase() + '^FS';
    zpl += '^FO180,220^ARN,10,10^FD' + caducidad.format('DD/MM/YYYY') + '^FS';

    zpl += '^FX seccion de codigo de barras';
    zpl += '^FO350,120^BQ,70,4^FDQA,' + data.referencia + '^FS';

    zpl += '^FO335,225^AQN,10,10^FD' + data.referencia + '^FS';

    zpl += '^PQ' + data.num_imp;

    zpl += '^XZ';


    return zpl;
  }

  /**
   * Modelo de etiqueta nuevo
   *
   */
  produccionModelo_2(data, tituloAlternativo = null) {

    let corte = 14;
    moment.locale('es');

    let tituloFinal = tituloAlternativo || data.nombre;

    let titulo = tituloFinal.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[\u00b9-\u00be]/g, '');
    let titulo_leng = titulo.length;
    let palabras = titulo.split(' ');

    let suma = 0;

    for (const element of palabras) {

      let suma_aux = element.length + 1 + suma;

      if (suma_aux > corte) {

        corte = suma == 0 ? corte : suma;
        break;

      } else {

        suma = suma_aux;
      }
    }

    const fechaCongelacion = moment(data.fecha_fin);

    let fechaDecongelacion = data.descongelacion ? moment(data.fecha_fin).format('DD/MM/YYYY HH:mm') : '';
    let fechaInicioDeUso = data.descongelacion ? moment(data.fecha_fin).add(data.tiempo_descongelacion, 'hours') : moment(data.fecha_fin);
    let fechaCaducidadPrimaria = data.caducidad_primaria ? moment(data.caducidad_primaria).format('DD/MM/YYYY') : '';

    if (fechaCaducidadPrimaria && data.caducidad_primaria_has_time && data.caducidad_primaria_time) {

      let fechaCadAndTime = data.caducidad_primaria + ' ' + data.caducidad_primaria_time + ':00';
      fechaCaducidadPrimaria = moment(fechaCadAndTime).format('DD/MM/YYYY HH:mm');
    }

    let fechaCaducidad = data.fecha_cad ? moment(data.fecha_cad) : moment(data.fecha_caducidad);

    if (data.descongelacion) {

      fechaCaducidad.add(data.tiempo_descongelacion, 'hours');

    } else if (data.apertura) {

      let tiempo_apertura_hours = data.tiempo_apertura * 24;
      fechaCaducidad = moment(data.fecha_fin).add(tiempo_apertura_hours, 'hours');
    }


    let primariaEsMenor = false;

    if (data.caducidad_primaria && fechaCaducidad && moment(data.caducidad_primaria) < fechaCaducidad) {
      primariaEsMenor = true;
      fechaCaducidad = moment(data.caducidad_primaria);
    }

    let zpl: string = '';

    zpl += '^XA';
    zpl += '^FX Seccion modelo nuevo';
    zpl += '^FO25,' + (titulo_leng > corte ? 20 : 40) + '^APN,50,50^FD' + (titulo.substr(0, corte)) + '^FS';
    zpl += '^FO25,65^APN,50,50^FD' + (titulo.substr(corte, 14)) + '^FS';


    zpl += '^FO25,150^AQN,10,10^FDCaducidad primaria^FS';
    zpl += '^FO25,190^ARN,10,10^FD' + (fechaCaducidadPrimaria) + '^FS';

    zpl += '^FO260,150^AQN,10,10^FDLote^FS';
    zpl += '^FO260,190^ARN,10,10^FD' + (data.lote ? data.lote : '') + '^FS';


    zpl += '^FO25,250^AQN,10,10^FD' + (data.descongelacion ? 'Fecha descongelacion' : '') + '^FS';
    zpl += '^FO25,290^ARN,10,10^FD' + fechaDecongelacion + '^FS';


    zpl += '^FO260,250^AQN,10,10^FDUsuario^FS';
    zpl += '^FO260,290^ARN,10,10^FD' + ((data.usuario).slice(0, 11)).normalize('NFD').replace(/[\u0300-\u036f]/g, '') + '^FS';


    if (data.descongelacion) {
      zpl += '^FO25,355^AQN,10,10^FDInicio de uso^FS';

    } else {
      zpl += '^FO25,355^AQN,10,10^FD' + (data.apertura ? 'Apertura envase' : 'Fecha produccion') + '^FS';
    }

    zpl += '^FO25,385^ARN,10,10^FD' + (!data.congelacion ? fechaInicioDeUso.format('DD/MM/YYYY HH:mm') : '') + '^FS';


    if (data.congelacion) {
      zpl += '^FO260,355^AQN,10,10^FDFecha congelacion^FS';
      zpl += '^FO260,385^ARN,10,10^FD' + ((fechaCongelacion.format('dddd')).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleUpperCase()) + '^FS';
      zpl += '^FO260,420^ARN,10,10^FD' + fechaCongelacion.format('DD/MM/YYYY HH:mm') + '^FS';

    } else {
      zpl += '^FO260,355^AQN,10,10^FDFecha caducidad^FS';
      zpl += '^FO260,385^ARN,10,10^FD' + ((fechaCaducidad.format('dddd')).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleUpperCase()) + '^FS';
      zpl += '^FO260,420^ARN,10,10^FD' + (primariaEsMenor && fechaCaducidadPrimaria ? fechaCaducidadPrimaria : fechaCaducidad.format('DD/MM/YYYY HH:mm')) + '^FS';
    }


    zpl += '^FX seccion de codigo de barras';

    zpl += '^FO360,10^BQ,2,4^FDQA,' + data.referencia + '^FS';

    zpl += '^FO360,110^AQN,10,10^FD' + data.referencia + '^FS';


    zpl += '^FX seccion de cuadros';

    zpl += '^FO1,1^GB490,140,1^FS';
    zpl += '^FO1,1^GB340,140,1^FS';
    zpl += '^FO1,140^GB490,105,1^FS';
    zpl += '^FO1,244^GB490,105,1^FS';
    zpl += '^FO1,348^GB490,120,1^FS';
    zpl += '^FO1,140^GB245,328,1^FS';

    zpl += '^PQ' + data.num_imp;

    zpl += '^XZ';

    return zpl;
  }


  /**
   * Modelo de etiqueta completa
   *
   */
  produccionModelo_3(data, tituloAlternativo = null) {

    moment.locale('es');

    let corte = 14;
    let corteDireccion = 40;

    let tituloFinal = tituloAlternativo || data.nombre;

    let titulo = tituloFinal.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[\u00b9-\u00be]/g, '');
    let tituloLength = titulo.length;
    let palabras = titulo.split(' ');

    let suma = 0;

    for (const element of palabras) {

      let suma_aux = element.length + 1 + suma;

      if (suma_aux > corte) {

        corte = suma == 0 ? corte : suma;
        break;

      } else {

        suma = suma_aux;
      }
    }

    const direccion: string = data.datos_empresa ? data.datos_empresa.direccion.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[\u00b9-\u00be]/g, '') : '';
    const palabrasDireccion = direccion.split(' ');

    let sumaDireccion = 0;

    for (const element of palabrasDireccion) {

      let suma_aux = element.length + 1 + sumaDireccion;

      if (suma_aux > corteDireccion) {

        corteDireccion = sumaDireccion == 0 ? corteDireccion : sumaDireccion;
        break;

      } else {

        sumaDireccion = suma_aux;
      }
    }

    let alergenos = data.alergenos_nombres || '-';
    const alergenosLength = alergenos.length;
    let corteFila = 0;
    let corteFila2 = 0;

    if (alergenosLength >= 61) {
      const strAux = alergenos.slice(0, 61);
      corteFila = strAux.lastIndexOf(' ') + 1;
    }

    if ((alergenosLength > 61 && alergenosLength < 122) || alergenosLength > 122) {
      const strAux2 = alergenos.slice(corteFila, 122);

      if (alergenosLength > 122) {
        corteFila2 = strAux2.lastIndexOf(' ') + 1 + corteFila;
      }
    }

    if (alergenosLength > 180) {
      alergenos = alergenos.slice(0, 180) + '...';
    }

    let ingredientes = data.ingredientes_nombres || '-';
    const ingredientesLength = ingredientes.length;
    let corteFilaIng = 0;
    let corteFilaIng2 = 0;
    let corteFilaIng3 = 0;
    let corteFilaIng4 = 0;
    let corteFilaIng5 = 0;

    if (ingredientesLength >= 61) {
      const strAux = ingredientes.slice(0, 61);
      corteFilaIng = strAux.lastIndexOf(' ') + 1;
    }

    if ((ingredientesLength > 61 && ingredientesLength < 122) || ingredientesLength > 122) {
      const strAux2 = ingredientes.slice(corteFilaIng, 122);

      if (ingredientesLength > 122) {
        corteFilaIng2 = strAux2.lastIndexOf(' ') + 1 + corteFilaIng;
      }
    }

    if ((ingredientesLength > 122 && ingredientesLength < 180) || ingredientesLength > 180) {
      const strAux3 = ingredientes.slice(corteFilaIng2, 180);

      if (ingredientesLength > 180) {
        corteFilaIng3 = strAux3.lastIndexOf(' ') + 1 + corteFilaIng2;
      }
    }

    if ((ingredientesLength > 180 && ingredientesLength < 244) || ingredientesLength > 244) {
      const strAux4 = ingredientes.slice(corteFilaIng3, 244);

      if (ingredientesLength > 244) {
        corteFilaIng4 = strAux4.lastIndexOf(' ') + 1 + corteFilaIng3;
      }
    }

    if ((ingredientesLength > 244 && ingredientesLength < 305) || ingredientesLength > 305) {
      const strAux5 = ingredientes.slice(corteFilaIng4, 305);

      if (ingredientesLength > 305) {
        corteFilaIng5 = strAux5.lastIndexOf(' ') + 1 + corteFilaIng4;
      }
    }

    if (ingredientesLength > 366) {
      ingredientes = ingredientes.slice(0, 366) + '...';
    }

    const fechaCongelacion = moment(data.fecha_fin);

    const fechaDecongelacion = data.descongelacion ? moment(data.fecha_fin).format('DD/MM/YYYY HH:mm') : '';
    const fechaInicioDeUso = data.descongelacion ? moment(data.fecha_fin).add(data.tiempo_descongelacion, 'hours') : moment(data.fecha_fin);
    let fechaCaducidadPrimaria = data.caducidad_primaria ? moment(data.caducidad_primaria).format('DD/MM/YYYY') : '';

    if (fechaCaducidadPrimaria && data.caducidad_primaria_has_time && data.caducidad_primaria_time) {

      const fechaCadAndTime = data.caducidad_primaria + ' ' + data.caducidad_primaria_time + ':00';
      fechaCaducidadPrimaria = moment(fechaCadAndTime).format('DD/MM/YYYY HH:mm');
    }

    let fechaCaducidad = data.fecha_cad ? moment(data.fecha_cad) : moment(data.fecha_caducidad);

    if (data.descongelacion) {

      fechaCaducidad.add(data.tiempo_descongelacion, 'hours');

    } else if (data.apertura) {

      const tiempo_apertura_hours = data.tiempo_apertura * 24;
      fechaCaducidad = moment(data.fecha_fin).add(tiempo_apertura_hours, 'hours');
    }

    let primariaEsMenor = false;

    if (data.caducidad_primaria && fechaCaducidad && moment(data.caducidad_primaria) < fechaCaducidad) {
      primariaEsMenor = true;
      fechaCaducidad = moment(data.caducidad_primaria);
    }

    let zpl = '';

    zpl += '^XA';
    zpl += '^FX Seccion etiqueta completa';
    zpl += '^FO25,' + (tituloLength > corte ? 20 : 40) + '^APN,50,50^FD' + (titulo.substr(0, corte)) + '^FS';
    zpl += '^FO25,65^APN,50,50^FD' + (titulo.substr(corte, 14)) + '^FS';


    zpl += '^FO25,150^AQN,10,10^FDCaducidad primaria^FS';
    zpl += '^FO25,190^ARN,10,10^FD' + (fechaCaducidadPrimaria) + '^FS';

    zpl += '^FO260,150^AQN,10,10^FDLote^FS';
    zpl += '^FO260,190^ARN,10,10^FD' + (data.lote || '') + '^FS';


    zpl += '^FO25,250^AQN,10,10^FD' + (data.descongelacion ? 'Fecha descongelacion' : '') + '^FS';
    zpl += '^FO25,290^ARN,10,10^FD' + fechaDecongelacion + '^FS';

    zpl += '^FO260,250^AQN,10,10^FDUsuario^FS';
    zpl += '^FO260,290^ARN,10,10^FD' + ((data.usuario).slice(0, 11)).normalize('NFD').replace(/[\u0300-\u036f]/g, '') + '^FS';


    if (data.descongelacion) {
      zpl += '^FO25,355^AQN,10,10^FDInicio de uso^FS';

    } else {
      zpl += '^FO25,355^AQN,10,10^FD' + (data.apertura ? 'Apertura envase' : 'Fecha produccion') + '^FS';
    }

    zpl += '^FO25,385^ARN,10,10^FD' + (!data.congelacion ? fechaInicioDeUso.format('DD/MM/YYYY HH:mm') : '') + '^FS';


    if (data.congelacion) {
      zpl += '^FO260,355^AQN,10,10^FDFecha congelacion^FS';
      zpl += '^FO260,385^ARN,10,10^FD' + ((fechaCongelacion.format('dddd')).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleUpperCase()) + '^FS';
      zpl += '^FO260,420^ARN,10,10^FD' + fechaCongelacion.format('DD/MM/YYYY HH:mm') + '^FS';

    } else {
      zpl += '^FO260,355^AQN,10,10^FDFecha caducidad^FS';
      zpl += '^FO260,385^ARN,10,10^FD' + ((fechaCaducidad.format('dddd')).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleUpperCase()) + '^FS';
      zpl += '^FO260,420^ARN,10,10^FD' + (primariaEsMenor && fechaCaducidadPrimaria ? fechaCaducidadPrimaria : fechaCaducidad.format('DD/MM/YYYY HH:mm')) + '^FS';
    }

    zpl += '^FO25,480^AQN,10,10^FDAlergenos^FS';
    zpl += '^FO25,515^APN,10,10^FD' + ((alergenos).slice(0, corteFila || 61)).normalize('NFD').replace(/[\u0300-\u036f]/g, '') + '^FS';

    if (corteFila) {
      zpl += '^FO25,535^APN,10,10^FD' + ((alergenos).slice(corteFila, corteFila2 || 122)).normalize('NFD').replace(/[\u0300-\u036f]/g, '') + '^FS';
    }

    if (corteFila2) {
      zpl += '^FO25,555^APN,10,10^FD' + ((alergenos).slice(corteFila2, 183)).normalize('NFD').replace(/[\u0300-\u036f]/g, '') + '^FS';
    }

    zpl += ' ^FO25,615^AQN,10,10^FDIngredientes^FS';
    zpl += '^FO25,650^APN,10,10^FD' + ((ingredientes).slice(0, corteFilaIng || 61)).normalize('NFD').replace(/[\u0300-\u036f]/g, '') + '^FS';

    if (corteFilaIng) {
      zpl += '^FO25,670^APN,10,10^FD' + ((ingredientes).slice(corteFilaIng, corteFilaIng2 || 122)).normalize('NFD').replace(/[\u0300-\u036f]/g, '') + '^FS';
    }

    if (corteFilaIng2) {
      zpl += '^FO25,690^APN,10,10^FD' + ((ingredientes).slice(corteFilaIng2, corteFilaIng3 || 183)).normalize('NFD').replace(/[\u0300-\u036f]/g, '') + '^FS';
    }

    if (corteFilaIng3) {
      zpl += '^FO25,710^APN,10,10^FD' + ((ingredientes).slice(corteFilaIng3, corteFilaIng4 || 244)).normalize('NFD').replace(/[\u0300-\u036f]/g, '') + '^FS';
    }

    if (corteFilaIng4) {
      zpl += '^FO25,730^APN,10,10^FD' + ((ingredientes).slice(corteFilaIng4, corteFilaIng5 || 305)).normalize('NFD').replace(/[\u0300-\u036f]/g, '') + '^FS';
    }

    if (corteFilaIng5) {
      zpl += '^FO25,730^APN,10,10^FD' + ((ingredientes).slice(corteFilaIng5, 360)).normalize('NFD').replace(/[\u0300-\u036f]/g, '') + '^FS';
    }

    zpl += '^FO25,800^AQN,10,10^FD' + (data.registro_sanitario ? 'Reg. Sanitario: ' + data.registro_sanitario : '') + '^FS';

    zpl += '^FO25,840^AQN,30,30^FD' + (data.datos_empresa ? data.datos_empresa.nombre : '') + '^FS';
    zpl += '^FO25,870^AQN,10,10^FD' + (data.datos_empresa ? 'CIF: ' + data.datos_empresa.cif : '') + '^FS';
    zpl += '^FO25,900^AQN,10,10^FD' + (direccion.substr(0, corteDireccion)) + '^FS';
    zpl += '^FO25,925^AQN,10,10^FD' + (direccion.substr(corteDireccion, 18)) + '^FS';

    zpl += '^FX seccion de codigo de barras';
    zpl += '^FO360,10^BQ,2,4^FDQA,' + data.referencia + '^FS';

    zpl += '^FO360,110^AQN,10,10^FD' + data.referencia + '^FS';

    zpl += '^FX seccion de cuadros';

    zpl += '^FO1,1^GB490,140,1^FS';
    zpl += '^FO1,1^GB340,140,1^FS';

    zpl += '^FO1,140^GB490,105,1^FS';
    zpl += '^FO1,244^GB490,105,1^FS';
    zpl += '^FO1,348^GB490,120,1^FS';
    zpl += '^FO1,467^GB490,135,1^FS';
    zpl += '^FO1,602^GB490,180,1^FS';

    zpl += '^FO1,140^GB245,328,1^FS';

    zpl += '^PQ' + data.num_imp;
    zpl += '^XZ';

    return zpl;
  }


  /**
   * Modelo de etiqueta sencilla con lote
   *
   */
  produccionModelo_4(data, tituloAlternativo = null) {

    let corte = 18;
    moment.locale('es');
    let produccion = moment(data.fecha_fin ? data.fecha_fin : data.fecha_impresion);
    let caducidad = moment(data.fecha_cad ? data.fecha_cad : data.fecha_caducidad);

    let tituloFinal = tituloAlternativo || data.nombre;

    let titulo = tituloFinal.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[\u00b9-\u00be]/g, "");
    let titulo_leng = titulo.length;
    let palabras = titulo.split(" ");

    let suma = 0;

    for (const element of palabras) {

      let suma_aux = element.length + 1 + suma;

      if (suma_aux > corte) {

        corte = suma == 0 ? corte : suma;
        break;

      } else {

        suma = suma_aux;
      }
    }

    let zpl: string = '';

    zpl += '^XA';
    zpl += '^FX Seccion';
    zpl += '^FO15,' + (titulo_leng > corte ? 10 : 40) + '^APN,50,50^FD' + (titulo.substr(0, corte)) + '^FS';
    zpl += '^FO15,60^APN,50,50^FD' + (titulo.substr(corte)) + '^FS';

    zpl += '^FO15,' + (titulo_leng > corte ? 120 : 115) + '^AQN,10,10^FDLote: ' + data.lote + '^FS';

    zpl += '^FO15,155^AQN,10,10^FDElaborado^FS';
    zpl += '^FO15,185^ARN,10,10^FD' + ((data.usuario).slice(0, 11)).normalize("NFD").replace(/[\u0300-\u036f]/g, "") + '^FS'; // 9
    zpl += '^FO15,220^ARN,10,10^FD' + produccion.format('DD/MM/YYYY') + '^FS';

    zpl += '^FO180,155^AQN,10,10^FDCaducidad^FS';
    zpl += '^FO180,185^ARN,10,10^FD' + (caducidad.format('dddd')).normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLocaleUpperCase() + '^FS';
    zpl += '^FO180,220^ARN,10,10^FD' + caducidad.format('DD/MM/YYYY') + '^FS';

    zpl += '^FX seccion de codigo de barras';
    zpl += '^FO335,120^BQ,70,4^FDQA,' + data.referencia + '^FS';

    zpl += '^FO335,225^AQN,10,10^FD' + data.referencia + '^FS';

    zpl += '^PQ' + data.num_imp;

    zpl += '^XZ';

    return zpl;
  }


  /**
   * Plantilla de la etiqueta avanzada
   *
   */
  plantillaEtiqueta(data, ip: string, num = 1) {

    let corte = 18;

    const titulo = !data.plantilla_vacia ? data.nombre.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[\u00b9-\u00be]/g, '') : '';
    const tituloLength = titulo.length;
    const palabras = titulo.split(' ');

    let suma = 0;

    for (const element of palabras) {
      const sumaAux = element.length + 1 + suma;

      if (sumaAux > corte) {
        corte = suma === 0 ? corte : suma;
        break;

      } else {
        suma = sumaAux;
      }
    }

    let zpl = '';

    zpl += '^XA';
    zpl += '^FX Seccion etiqueta avanzada';
    zpl += '^FO25,' + (tituloLength > corte ? 20 : 40) + '^APN,50,50^FD' + (titulo.substr(0, corte)) + '^FS';
    zpl += '^FO25,65^APN,50,50^FD' + (titulo.substr(corte, 18)) + '^FS';

    zpl += '^FO25,150^AQN,10,10^FDCaducidad primaria^FS';

    zpl += '^FO260,150^AQN,10,10^FDLote^FS';

    zpl += '^FO25,250^AQN,10,10^FD' + (data.descongelacion ? 'Fecha descongelacion' : '') + '^FS';

    zpl += '^FO260,250^AQN,10,10^FDUsuario^FS';

    if (data.descongelacion) {
      zpl += '^FO25,355^AQN,10,10^FDInicio de uso^FS';

    } else {
      zpl += '^FO25,355^AQN,10,10^FD' + (data.apertura ? 'Apertura envase' : 'Fecha produccion') + '^FS';
    }

    zpl += '^FO260,355^AQN,10,10^FD' + (data.congelacion ? 'Fecha congelacion' : 'Fecha caducidad') + '^FS';

    zpl += '^FX seccion de cuadros';
    zpl += '^FO1,1^GB490,140,1^FS';
    zpl += '^FO1,140^GB490,105,1^FS';
    zpl += '^FO1,244^GB490,105,1^FS';
    zpl += '^FO1,348^GB490,120,1^FS';
    zpl += '^FO1,140^GB245,328,1^FS';

    zpl += '^PQ' + num;

    zpl += '^XZ';

    this.sentdToPrint(ip, zpl);
  }


  /**
   * Modelo de etiqueta redonda
   *
   */
  modelEtiquetaRedonda(data) {

    moment.locale('es');

    let caducidad = moment(data.fecha_cad || data.fecha_caducidad);

    let titulo = data.nombre.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[\u00b9-\u00be]/g, '');
    const tituloLength = titulo.length;
    const palabras = titulo.split(' ');

    let corte = 14;
    let suma = 0;

    for (const element of palabras) {
      const sumaAux = element.length + 1 + suma;

      if (sumaAux > corte) {
        corte = suma === 0 ? corte : suma;
        break;

      } else {
        suma = sumaAux;
      }
    }

    let zpl = '';

    zpl += '^XA';

    zpl += this.getLogosClientes(data.id_cliente);

    zpl += '^FO0,100^GB320,3,3^FS';

    zpl += '^FO' + this.centerName(titulo.slice(0, corte)) + ',' + (tituloLength > corte ? 100 : 125) + '^APN,50,50^FD' + (titulo.slice(0, corte)) + '^FS';
    zpl += '^FO' + this.centerName(titulo.slice(corte)) + ',145^APN,50,50^FD' + (titulo.slice(corte)) + '^FS';

    zpl += '^FO0,200^GB320,3,3^FS';

    zpl += '^FO85,212^AQN,10,10^FDFecha caducidad^FS';
    zpl += '^FO95,240^ARN,10,10^FD' + caducidad.format('DD/MM/YYYY') + '^FS';

    zpl += '^FO120,285^APN,1,1^FD' + data.referencia + '^FS';

    zpl += '^PQ' + data.num_imp;

    zpl += '^XZ';

    return zpl;
  }


  /**
   * Centrar nombre
   *
   */
  private centerName(name: string, labelWidth: number = 14): number {
    const textLength: number = name.length;
    const textLengthCenter: number = Math.max(Math.floor((labelWidth - textLength) / 2), 0.9);

    const textPosition: number = (() => {
      if (textLengthCenter === 1) return 45;
      if (textLengthCenter === 2) return 35;
      if (textLengthCenter > 2 && textLengthCenter < 4) return 28;
      if (textLengthCenter >= 4 && textLengthCenter < 8) return 24;
      if (textLengthCenter >= 8 && textLengthCenter < 10) return 20;
      if (textLengthCenter >= 10 && textLengthCenter < 14) return 15;
      return 28;
    })();

    return Math.floor(textLengthCenter * textPosition);
  }


  /**
   * Obtener logos clientes
   *
   */
  getLogosClientes(cliente: number): string {
    switch (cliente) {
      case 1: // Grupo Gómez
        return '^FO90,25^GFA,1040,1040,16,U088,R01E08838,R02308844,R02108844,P01816088441,P02C1A0887C24,P040110988042,P0421106080C2,P041M082,P021M086,P032M044,P01CM038,,V0E,U03E,U07E,U078,U04,,J0F8K07C007C,F803FE03FE0FF01FE03E3E0FFC3FF8,F803FE07FE1FF81FF03F3E0FFC3FF8,F807FF0FFE3FF83FF83F7E0FFC3FF8,F807DF0F003EF83EF83F7E0F8I0F8,F8078F0E003E783C783FFE0FJ0F8,F8078F0E003C783C783FFE0FJ0F,F8078F0E003C783C783FFE0FI01F,:F8078F0F003C783C783FFE0FI01E,F8078F0F003C003C783FFE0FI03E,F8078F0F803C003C783FFE0FI03E,F8078F0FC03C003C783DDE0FI03E,F8078F0FE03C003C783DDE0FFC03C,F8078F0FF03C003C783C9E0FFC07C,F8078F07F83C003C783C9E0FFC07C,F8078F03F83CF83C783C1E0FFC07C,F8078F01FC3CF83C783C1E0F80078,F8078F00FC3CF83C783C1E0FI0F8,:F8078F007C3C783C783C1E0FI0F8,F8078F003C3C783C783C1E0FI0F,F8078F001C3C783C783C1E0F001F,::F8078F001C3C783C783C1E0F001E,F8078F001C3C783C783C1E0F003E,FF878F0FFC3E783CF83C1E0FFC3FF8F,FFC7FF0FFC1FF83FF03C1E0FFC3FF8F,FFC3FE0FF81FF01FF03C1E0FFC3FF8F,FF81FC0FF00FE00FE03C1E0FFC3FF8F,,::::::I070101C3E3C0E0801810801C0E,I0C818220822110C46630C42213,I08018200822310C44239C46021,I080243808I208A44239C44021,I09C240E083C208944229I4021,I0847C0208243189C4226446021,I08C4I208221108C6626442211,I070421C08220E0843C06041C0E,^FS';

      case 986: // Lassal
        return '^FO100,30^GFA,795,795,15,,:::::::004,03EgK0E,07CgJ07E,03CgJ03E,:03CgJ03C,::::::::03C003FCI03FI03F8I03FC003C,03C01IF801FFE01IF001IF803C,03C03803C0380703807803803C03C,03C0F001E070018700180E001E03C,03C0CI0F0EI087I080CI0F03C,03C08I0F0EJ0EK08I0F03C,03CK0F8EJ0FO0F03C,03CK0F8FJ0FO0F03C,03CK0F8F8I0F8N0F83C,03CI078F8FEI0FEL078F83C,03C00JF87FC007FCJ0JF83C,03C03E00F87FF803FF8003C00F83C,03C0F800F81FFE01FFE00F800F83C,03C1FI0F807FF007FF81FI0F83C,03C3EI0F801FF800FFC3EI0F83C,03C3EI0F8001FC001FC3CI0F83C,03C3CI0F8I07CI03E3CI0F83C,03C3CI0F8I01EI01E3CI0F83C,03C3CI0F8J0EJ0E3CI0F83C,03C3EI0F8J0EJ0E3EI0F83C,03C3E001F8J0CJ0E3E001F83C,03C1F003F8J0CJ0C1F003F83C,03C0F80EFCI01CJ0C0F80EFC3E,07E07FFCF8I018I01807FFCF83E,04201FF0CJ03J03001FF0C07F,S0EJ0E,R07CI07C,Q07FI07F,Q07CI07C,Q02J03,,^FS';

      default: // Yurest
        return '^FO100,40^GFA,688,688,16,gM01E,::::::FC003E1FI0FC383E07FC001FF01FFE,FC007E3F800FC38FE1IF007FFE1IF,FC007E3F800FC39FE3IF80IFE1IF,FC007E3F800FC3BE07C07C1F00E1E,FC007E3F800FC3F80F001E1EI01E,FC007E3F800FC3E01EI0E1CI01E,FC007E3F800FC3C01EI0F3CI01E,FC007E3F800FC3C03CI073CI01E,FC007E3F800FC3803CI079EI01E,FC007E3F800FC3803CI079FI01E,FC007E3F800FC38038I078FC001E,FC007E3F800FC3803CI0787FC01E,FC007E3F800FC3803KF83FF01E,FC007E3F800FC3803KF807FC1E,FC007E3F800FC3803CM07E1E,FC007E3F800FC38038M01F1E,FE007E1F800FC3803CN0F1E,FE007E1F801FC3803CN071E,FF00FE1FC01FC3801CN071E,7F81FE1FE03F83801EI06J071E,7JFE0FFDFF83800FI0FJ0F0E,3JFE0KF03800F803E0801F0F,1JFE07IFE038007E0FC1F03E0FC7,0JFE03IFC038001IF81IFC07FF,03IFE00IF8038I0FFE007FF003FF,00FEFE003FC0038J0EJ078I07,J0FE,:I01FC,I03FC,1F1FF8,3JF8,7JF,7IFE,3IF8,07FE,^FS';
    }
  }


  /**
   * Editueta demo Saona
   *
   */
  produccionVoltera() {

    let zpl: String = '';
    zpl += '^XA';

    zpl += '^FX Seccion';
    zpl += '^FO25,10^APN,50,50^FDAlbondigas en ^FS';
    zpl += '^FO25,55^APN,50,50^FDsalsa de tomate^FS';


    zpl += '^FO25,135^AQN,10,10^FDCaducidad primaria^FS';
    zpl += '^FO25,170^ARN,10,10^FD15/04/2021 00:00^FS';

    zpl += '^FO260,135^AQN,10,10^FDLote^FS';
    zpl += '^FO260,170^ARN,10,10^FD62538738^FS';


    zpl += '^FO25,240^AQN,10,10^FDFecha descongelacion^FS';
    zpl += '^FO25,275^ARN,10,10^FD15/04/2021 00:00^FS';

    zpl += '^FO260,240^AQN,10,10^FDUsuario^FS';
    zpl += '^FO260,275^ARN,10,10^FDMarcos G^FS';


    zpl += '^FO25,335^AQN,10,10^FDInicio de uso^FS';
    zpl += '^FO25,370^ARN,10,10^FD15/04/2021 00:00^FS';

    zpl += '^FO260,335^AQN,10,10^FDFecha caducidad^FS';
    zpl += '^FO260,370^ARN,10,10^FD15/04/2021 00:00^FS';


    zpl += '^FX seccion de codigo de barras';

    zpl += '^FO380,10^BQ,2,4^FDQA,R000028018^FS';


    zpl += '^FX seccion de cuadros';

    zpl += '^FO1,1^GB490,120,1^FS';
    zpl += '^FO1,1^GB365,120,1^FS';

    zpl += '^FO1,120^GB490,100,1^FS';
    zpl += '^FO1,219^GB490,100,1^FS';
    zpl += '^FO1,318^GB490,100,1^FS';

    zpl += '^FO1,120^GB245,298,1^FS';

    zpl += '^XZ';
  }


  /**
   *
   *
   */
  sendByWS(zpl) {
    let socket = new (<any>window).Socket();

    socket.open('192.168.2.126', 9100,

      () => {

        alert('yeas');

      },
      (error) => {

      });
  }
}



// WEBPACK FOOTER //
// ./src/classes/impresion.ts